import { createSelector } from 'reselect';
var getRoot = function (_a) {
    var auth = _a.auth;
    return auth;
};
export var getAuthToken = createSelector(getRoot, function (_a) {
    var token = _a.token;
    return token;
});
